import React from "react";
import me from "../asset/me.JPEG";

function MobileSection3Inner() {
  return (
    <div className="flex flex-col gap-[1rem] items-center">
      <div className="rounded-[5px] overflow-hidden text-[20px] text-white h-[220px] w-[90vw] border border-[#404140] ">
        <div className="h-[12%] bg-[#0f0f0f] border-b-[#404140] border-b w-full flex justify-between items-center px-4 opacity-[0.7]">
          <p className=" text-[3.0vw] font-[500]">summary</p>
          <div className=" flex gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 16 16"
              class="icon"
              width="1rem"
              height="1rem"
              data-v-d1e61456=""
            >
              <path
                fill="#404140"
                d="M2.67 8c0-.37.3-.67.66-.67h9.34a.67.67 0 1 1 0 1.34H3.33A.67.67 0 0 1 2.67 8"
              ></path>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              class="icon"
              width="1rem"
              height="1rem"
              data-v-d1e61456=""
            >
              <path
                fill="#404140"
                d="M8.2 4c-1.12 0-1.82-.05-2.56.33a3 3 0 0 0-1.31 1.3C3.95 6.39 4 7.09 4 8.2v7.6c0 1.12-.05 1.82.33 2.56a3 3 0 0 0 1.3 1.31c.75.38 1.45.33 2.57.33h7.6c1.12 0 1.82.05 2.56-.33a3 3 0 0 0 1.31-1.3c.38-.75.33-1.45.33-2.57V8.2c0-1.12.05-1.82-.33-2.56a3 3 0 0 0-1.3-1.31C17.61 3.95 16.91 4 15.8 4Zm0 2h7.6c1.12 0 1.54.05 1.65.1a1 1 0 0 1 .44.45c.06.11.11.53.11 1.65v7.6c0 1.12-.05 1.54-.1 1.65a1 1 0 0 1-.45.44c-.11.06-.53.11-1.65.11H8.2a6 6 0 0 1-1.65-.1 1 1 0 0 1-.44-.45A6 6 0 0 1 6 15.8V8.2c0-1.12.05-1.54.1-1.65a1 1 0 0 1 .45-.44C6.66 6.05 7.08 6 8.2 6"
              ></path>
            </svg>
            <span className="cursor-pointer ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 16 16"
                class="icon"
                width="1rem"
                height="1rem"
                data-v-d1e61456=""
              >
                <path
                  fill="#404140"
                  d="M3.53 3.53a.67.67 0 0 1 .94 0L8 7.06l3.53-3.53a.67.67 0 1 1 .94.94L8.94 8l3.53 3.53a.67.67 0 1 1-.94.94L8 8.94l-3.53 3.53a.67.67 0 1 1-.94-.94L7.06 8 3.53 4.47a.67.67 0 0 1 0-.94"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <div className="h-[88%] bg-[#0f0f0f] opacity-[0.7] w-full text-[3.5vw] p-4 monospace">
          <p>
            I am <span className="text-[#89f480]">Subhajit Ghosh</span>, call me{" "}
            <span className="text-[#fde400]">orrin</span>. <br />
            My goal is to{" "}
            <span className="text-[#00d5ff]">apply my skills</span> as a{" "}
            <span className="text-[#c6ff28]">full-stack web developer</span> to
            build
            <span className="text-[#fb1dff]"> scalable solutions</span> and
            continuously{" "}
            <span className="text-[#ff6128]">expand my knowledge</span>. In the
            long run,
            <span className="text-[#5dff27]">I aspire to</span> master the{" "}
            <span className="text-[#ff1869]">web development</span>,
            <span className="text-[#2bd5ff]"> adapting to</span> the
            ever-evolving <span className="text-[#b5ff2b]">tech landscape</span>
            .
          </p>
        </div>
      </div>
      <div className="rounded-[5px] overflow-hidden text-[20px] text-white h-[280px] w-[90vw] border border-[#404140] ">
        <div className="h-[12%] bg-[#0f0f0f] border-b-[#404140] border-b w-full flex justify-between items-center px-4 opacity-[0.7]">
          <p className=" text-[3.0vw] font-[500]">education</p>
          <div className=" flex gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 16 16"
              class="icon"
              width="1rem"
              height="1rem"
              data-v-d1e61456=""
            >
              <path
                fill="#404140"
                d="M2.67 8c0-.37.3-.67.66-.67h9.34a.67.67 0 1 1 0 1.34H3.33A.67.67 0 0 1 2.67 8"
              ></path>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              class="icon"
              width="1rem"
              height="1rem"
              data-v-d1e61456=""
            >
              <path
                fill="#404140"
                d="M8.2 4c-1.12 0-1.82-.05-2.56.33a3 3 0 0 0-1.31 1.3C3.95 6.39 4 7.09 4 8.2v7.6c0 1.12-.05 1.82.33 2.56a3 3 0 0 0 1.3 1.31c.75.38 1.45.33 2.57.33h7.6c1.12 0 1.82.05 2.56-.33a3 3 0 0 0 1.31-1.3c.38-.75.33-1.45.33-2.57V8.2c0-1.12.05-1.82-.33-2.56a3 3 0 0 0-1.3-1.31C17.61 3.95 16.91 4 15.8 4Zm0 2h7.6c1.12 0 1.54.05 1.65.1a1 1 0 0 1 .44.45c.06.11.11.53.11 1.65v7.6c0 1.12-.05 1.54-.1 1.65a1 1 0 0 1-.45.44c-.11.06-.53.11-1.65.11H8.2a6 6 0 0 1-1.65-.1 1 1 0 0 1-.44-.45A6 6 0 0 1 6 15.8V8.2c0-1.12.05-1.54.1-1.65a1 1 0 0 1 .45-.44C6.66 6.05 7.08 6 8.2 6"
              ></path>
            </svg>
            <span className="cursor-pointer ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 16 16"
                class="icon"
                width="1rem"
                height="1rem"
                data-v-d1e61456=""
              >
                <path
                  fill="#404140"
                  d="M3.53 3.53a.67.67 0 0 1 .94 0L8 7.06l3.53-3.53a.67.67 0 1 1 .94.94L8.94 8l3.53 3.53a.67.67 0 1 1-.94.94L8 8.94l-3.53 3.53a.67.67 0 1 1-.94-.94L7.06 8 3.53 4.47a.67.67 0 0 1 0-.94"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <div className="h-[88%] bg-[#0f0f0f] opacity-[0.7] w-full text-[3.5vw] p-4 monospace">
          <p>
            <span className="text-[#89f480]">
              Bachelor Of Computer Application (BCA)
            </span>
            , <span className="text-[#00d5ff]">2025</span>
          </p>
          <p>
            from{" "}
            <span className="text-[#c6ff28]">
              Dr. B. C. Roy Engineering College
            </span>
            , <span className="">Durgapur</span>
          </p>
          <br />
          <p>
            <span className="text-[#ff6128]">Relevant Coursework</span>
          </p>
          <p>
            <span className="text-[#5dff27]">- Data Structure & Algorithm</span>
          </p>
          <p>
            <span className="text-[#ff1869]">
              - Object Oriented Programming
            </span>
          </p>
          <p>
            <span className="text-[#2bd5ff]">- Database Management System</span>
          </p>
          <p>
            <span className="text-[#ff28ff]">- Operating System</span>
          </p>
        </div>
      </div>
      <div className=" flex justify-between items-center w-[90vw]">
        <div className="rounded-[5px] overflow-hidden text-[20px] text-white h-[230px] w-[170px]  border border-[#404140] ">
          <div className="h-[15%] bg-[#0f0f0f] border-b-[#404140] border-b w-full flex justify-between items-center px-4 opacity-[0.7]">
            <p className=" text-[3.0vw] font-[500]">Backend</p>
            <div className=" flex gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 16 16"
                class="icon"
                width="1rem"
                height="1rem"
                data-v-d1e61456=""
              >
                <path
                  fill="#404140"
                  d="M2.67 8c0-.37.3-.67.66-.67h9.34a.67.67 0 1 1 0 1.34H3.33A.67.67 0 0 1 2.67 8"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
                class="icon"
                width="1rem"
                height="1rem"
                data-v-d1e61456=""
              >
                <path
                  fill="#404140"
                  d="M8.2 4c-1.12 0-1.82-.05-2.56.33a3 3 0 0 0-1.31 1.3C3.95 6.39 4 7.09 4 8.2v7.6c0 1.12-.05 1.82.33 2.56a3 3 0 0 0 1.3 1.31c.75.38 1.45.33 2.57.33h7.6c1.12 0 1.82.05 2.56-.33a3 3 0 0 0 1.31-1.3c.38-.75.33-1.45.33-2.57V8.2c0-1.12.05-1.82-.33-2.56a3 3 0 0 0-1.3-1.31C17.61 3.95 16.91 4 15.8 4Zm0 2h7.6c1.12 0 1.54.05 1.65.1a1 1 0 0 1 .44.45c.06.11.11.53.11 1.65v7.6c0 1.12-.05 1.54-.1 1.65a1 1 0 0 1-.45.44c-.11.06-.53.11-1.65.11H8.2a6 6 0 0 1-1.65-.1 1 1 0 0 1-.44-.45A6 6 0 0 1 6 15.8V8.2c0-1.12.05-1.54.1-1.65a1 1 0 0 1 .45-.44C6.66 6.05 7.08 6 8.2 6"
                ></path>
              </svg>
              <span className="cursor-pointer ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  class="icon"
                  width="1rem"
                  height="1rem"
                  data-v-d1e61456=""
                >
                  <path
                    fill="#404140"
                    d="M3.53 3.53a.67.67 0 0 1 .94 0L8 7.06l3.53-3.53a.67.67 0 1 1 .94.94L8.94 8l3.53 3.53a.67.67 0 1 1-.94.94L8 8.94l-3.53 3.53a.67.67 0 1 1-.94-.94L7.06 8 3.53 4.47a.67.67 0 0 1 0-.94"
                  ></path>
                </svg>
              </span>
            </div>
          </div>
          <div className="h-[88%] bg-[#0f0f0f] opacity-[0.5] w-full text-[3.5vw] p-4 monospace">
            <p>- Node JS</p>
            <p>- Express JS</p>
            <p>- Mongodb</p>
            <p>- Mongoose</p>
            <p>- PostgreSQL</p>
            <p>- Prisma</p>
            <p>- Clerk</p>
          </div>
        </div>
        <div className="rounded-[5px] overflow-hidden text-[3.5vw] text-white h-[230px] w-[170px] border border-[#404140] ">
          <div className="h-[12%] bg-[#0f0f0f] border-b-[#404140] border-b w-full flex justify-between items-center px-4 opacity-[0.7]">
            <p className="text-[3vw]  font-[500]">frontend</p>
            <div className=" flex gap-2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 16 16"
                class="icon"
                width="1rem"
                height="1rem"
                data-v-d1e61456=""
              >
                <path
                  fill="#404140"
                  d="M2.67 8c0-.37.3-.67.66-.67h9.34a.67.67 0 1 1 0 1.34H3.33A.67.67 0 0 1 2.67 8"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 24 24"
                class="icon"
                width="1rem"
                height="1rem"
                data-v-d1e61456=""
              >
                <path
                  fill="#404140"
                  d="M8.2 4c-1.12 0-1.82-.05-2.56.33a3 3 0 0 0-1.31 1.3C3.95 6.39 4 7.09 4 8.2v7.6c0 1.12-.05 1.82.33 2.56a3 3 0 0 0 1.3 1.31c.75.38 1.45.33 2.57.33h7.6c1.12 0 1.82.05 2.56-.33a3 3 0 0 0 1.31-1.3c.38-.75.33-1.45.33-2.57V8.2c0-1.12.05-1.82-.33-2.56a3 3 0 0 0-1.3-1.31C17.61 3.95 16.91 4 15.8 4Zm0 2h7.6c1.12 0 1.54.05 1.65.1a1 1 0 0 1 .44.45c.06.11.11.53.11 1.65v7.6c0 1.12-.05 1.54-.1 1.65a1 1 0 0 1-.45.44c-.11.06-.53.11-1.65.11H8.2a6 6 0 0 1-1.65-.1 1 1 0 0 1-.44-.45A6 6 0 0 1 6 15.8V8.2c0-1.12.05-1.54.1-1.65a1 1 0 0 1 .45-.44C6.66 6.05 7.08 6 8.2 6"
                ></path>
              </svg>
              <span className="cursor-pointer ">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 16 16"
                  class="icon"
                  width="1rem"
                  height="1rem"
                  data-v-d1e61456=""
                >
                  <path
                    fill="#404140"
                    d="M3.53 3.53a.67.67 0 0 1 .94 0L8 7.06l3.53-3.53a.67.67 0 1 1 .94.94L8.94 8l3.53 3.53a.67.67 0 1 1-.94.94L8 8.94l-3.53 3.53a.67.67 0 1 1-.94-.94L7.06 8 3.53 4.47a.67.67 0 0 1 0-.94"
                  ></path>
                </svg>
              </span>
            </div>
          </div>
          <div className="h-[88%] bg-[#0f0f0f] opacity-[0.5] w-full p-4 monospace">
            <p>- Typescript</p>
            <p>- Tailwind</p>
            <p>- React.js</p>
            <p>- Next.js</p>
            <p>- Zustand</p>
            <p>- Shadcn ui</p>
            <p>- WebSocket</p>
          </div>
        </div>
      </div>

      <div className="w-[230px] rounded-[5px] overflow-hidden text-white h-[300px] border border-[#404140] ">
        <div className="h-[8%] bg-[#0f0f0f] border-b-[#404140] border-b w-full flex justify-between items-center px-4 opacity-[0.7]">
          <p className=" text-[3.0vw] font-[500]">portrait</p>
          <div className=" flex gap-2">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 16 16"
              class="icon"
              width="1rem"
              height="1rem"
              data-v-d1e61456=""
            >
              <path
                fill="#404140"
                d="M2.67 8c0-.37.3-.67.66-.67h9.34a.67.67 0 1 1 0 1.34H3.33A.67.67 0 0 1 2.67 8"
              ></path>
            </svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 24 24"
              class="icon"
              width="1rem"
              height="1rem"
              data-v-d1e61456=""
            >
              <path
                fill="#404140"
                d="M8.2 4c-1.12 0-1.82-.05-2.56.33a3 3 0 0 0-1.31 1.3C3.95 6.39 4 7.09 4 8.2v7.6c0 1.12-.05 1.82.33 2.56a3 3 0 0 0 1.3 1.31c.75.38 1.45.33 2.57.33h7.6c1.12 0 1.82.05 2.56-.33a3 3 0 0 0 1.31-1.3c.38-.75.33-1.45.33-2.57V8.2c0-1.12.05-1.82-.33-2.56a3 3 0 0 0-1.3-1.31C17.61 3.95 16.91 4 15.8 4Zm0 2h7.6c1.12 0 1.54.05 1.65.1a1 1 0 0 1 .44.45c.06.11.11.53.11 1.65v7.6c0 1.12-.05 1.54-.1 1.65a1 1 0 0 1-.45.44c-.11.06-.53.11-1.65.11H8.2a6 6 0 0 1-1.65-.1 1 1 0 0 1-.44-.45A6 6 0 0 1 6 15.8V8.2c0-1.12.05-1.54.1-1.65a1 1 0 0 1 .45-.44C6.66 6.05 7.08 6 8.2 6"
              ></path>
            </svg>
            <span className="cursor-pointer ">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="currentColor"
                viewBox="0 0 16 16"
                class="icon"
                width="1rem"
                height="1rem"
                data-v-d1e61456=""
              >
                <path
                  fill="#404140"
                  d="M3.53 3.53a.67.67 0 0 1 .94 0L8 7.06l3.53-3.53a.67.67 0 1 1 .94.94L8.94 8l3.53 3.53a.67.67 0 1 1-.94.94L8 8.94l-3.53 3.53a.67.67 0 1 1-.94-.94L7.06 8 3.53 4.47a.67.67 0 0 1 0-.94"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <img src={me} className="h-full scale-[1] pointer-events-none" />
      </div>
    </div>
  );
}

export default MobileSection3Inner;
